/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_MarkersInputs */

const en_quicktools_tab_markers = /** @type {(inputs: Quicktools_Tab_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markers`)
};

const fr_quicktools_tab_markers = /** @type {(inputs: Quicktools_Tab_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marqueurs`)
};

const de_quicktools_tab_markers = /** @type {(inputs: Quicktools_Tab_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markierungen`)
};

const it_quicktools_tab_markers = /** @type {(inputs: Quicktools_Tab_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcatori`)
};

const ru_quicktools_tab_markers = /** @type {(inputs: Quicktools_Tab_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркеры`)
};

const es_quicktools_tab_markers = /** @type {(inputs: Quicktools_Tab_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores`)
};

const zh_cn2_quicktools_tab_markers = /** @type {(inputs: Quicktools_Tab_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标记`)
};

const ja_quicktools_tab_markers = /** @type {(inputs: Quicktools_Tab_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカー`)
};

const hi_quicktools_tab_markers = /** @type {(inputs: Quicktools_Tab_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्करों`)
};

const pt_pt2_quicktools_tab_markers = /** @type {(inputs: Quicktools_Tab_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores`)
};

/**
* | output |
* | --- |
* | "Markers" |
*
* @param {Quicktools_Tab_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_markers = /** @type {((inputs?: Quicktools_Tab_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_markers(inputs)
	if (locale === "de") return de_quicktools_tab_markers(inputs)
	if (locale === "it") return it_quicktools_tab_markers(inputs)
	if (locale === "ru") return ru_quicktools_tab_markers(inputs)
	if (locale === "es") return es_quicktools_tab_markers(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_markers(inputs)
	if (locale === "ja") return ja_quicktools_tab_markers(inputs)
	if (locale === "hi") return hi_quicktools_tab_markers(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_markers(inputs)
	return en_quicktools_tab_markers(inputs)
});